// src/utils/menuItems.js
import {
    FiGrid,
    FiUser,
    FiSettings,
    FiBarChart,
    FiBriefcase,
    FiCheckSquare,
    FiMonitor,
    FiClock,
    FiTool,
    FiHelpCircle,
    FiSearch,
    FiFileText,
    FiHome,
    FiEdit,
    FiArchive,
} from "react-icons/fi";
import { GoProject } from "react-icons/go";

// Menu items for each role
const ownerMenuItems = [
    { path: "/pregled", label: "Osnovni pregled", icon: <FiGrid /> },
    { path: "/agents", label: "Agenti", icon: <FiUser /> },
    { path: "/projects", label: "Projekti", icon: <GoProject /> },
    { path: "/admin", label: "Administracija", icon: <FiSettings /> },
    { path: "/marketing", label: "Marketing", icon: <FiBarChart /> },
    { path: "/stojacheck", label: "StojaCheck™", icon: <FiCheckSquare /> },
    // { path: '/dcs', label: 'DCS', icon: <FiMonitor /> },
    { path: "/odsotnosti", label: "Odsotnosti", icon: <FiClock /> },
    { path: "/racuni", label: "Računi", icon: <FiFileText /> },
    { path: "/archive", label: "Arhiv", icon: <FiArchive /> },
];

const managerMenuItems = [
    { path: "/pregled", label: "Osnovni pregled", icon: <FiGrid /> },
    { path: "/agents", label: "Agenti", icon: <FiUser /> },
    { path: "/projects", label: "Projekti", icon: <GoProject /> },
    { path: "/admin", label: "Administracija", icon: <FiSettings /> },
    { path: "/stojacheck", label: "StojaCheck™", icon: <FiCheckSquare /> },
    { path: "/odsotnosti", label: "Odsotnosti", icon: <FiClock /> },
    { path: "/racuni", label: "Računi", icon: <FiFileText /> },
    // { path: "/vpis-statistik", label: "Vpis statistik", icon: <FiEdit /> },
    { path: "/archive", label: "Arhiv", icon: <FiArchive /> },
];

const mixedMenuItems = [
    { path: "/profile", label: "Admin Portal", icon: <FiSettings /> },
    { path: "/vpis-statistik", label: "Vpis statistik", icon: <FiEdit /> },
    { path: "/odsotnosti", label: "Odsotnosti", icon: <FiClock /> },
    { path: "/pomoc", label: "Pomoč", icon: <FiHelpCircle /> },
];

const adminMenuItems = [
    { path: "/profile", label: "Admin Portal", icon: <FiSettings /> },
    { path: "/vpis-statistik", label: "Vpis statistik", icon: <FiEdit /> },
    { path: "/pomoc", label: "Pomoč", icon: <FiHelpCircle /> },
];

const adminMixedMenuItems = [
    { path: "/profile", label: "Admin Portal", icon: <FiSettings /> },
    { path: "/vpis-statistik", label: "Vpis statistik", icon: <FiEdit /> },
    { path: "/racuni", label: "Računi", icon: <FiFileText /> },
    { path: "/pomoc", label: "Pomoč", icon: <FiHelpCircle /> },
];

// Function to get menu items based on user role
export const getMenuItems = (role, permissions) => {
    switch (role) {
        case "owner":
            return ownerMenuItems;
        case "manager":
            return managerMenuItems;
        case "admin":
            if (
                !!permissions &&
                permissions.length > 0 &&
                permissions.includes("absences")
            ) {
                return mixedMenuItems;
            } else if (
                !!permissions &&
                permissions.length > 0 &&
                permissions.includes("invoices")
            ) {
                return adminMixedMenuItems;
            }
            return adminMenuItems;
        default:
            return [];
    }
};

// Export default menu items (for backward compatibility)
export const menuItems = getMenuItems("owner");
